<div style="width:50vw; min-width: 400px;">
    <forge-toolbar>
        <h2 slot="start" class="forge-typography--heading4">{{dialogTitle}}</h2>
        <div slot="end" class="forge-typography--heading2">{{dialogSubtitle}}</div>
    </forge-toolbar>

    <mat-dialog-content fxLayout="column" fxLayoutAlign="start stretch" style="padding: .5rem 1rem;">
        <forge-inline-message style="margin-bottom: 4px;">{{message}}</forge-inline-message>

        <drag-and-drop-list fxFlex [display]="display" [groups]="groups" [groupTitles]="groupTitles"
            [subtitleMember]="subtitleMember">
        </drag-and-drop-list>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="actions">
        <forge-button variant="outlined" (click)="close()">Cancel</forge-button>
        <forge-button variant="raised" (click)="add()">Save</forge-button>
    </mat-dialog-actions>
</div>